interface NotificationProps {
  text: string;
  dateTime?: string | Date;
}
const TypeNotification: React.FC<NotificationProps> = ({ text, dateTime }) => {
  return (
    <>
      <div className={'text-left text-xs text-tc-4'}>{dateTime}</div>
      <div className=" flex justify-center gap-4 text-tc-5 py-2">
        <div className="text-xs">{`${text}`}</div>
      </div>
    </>
  );
};

export default TypeNotification;
